import React from 'react'
import { useContext } from 'sb-hooks'
import { NotificationContext } from 'sb-notify-me'

import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'

import messages from './messages'
import s from './OutOfStockSubscription.scss'


const OutOfStockSubscription: React.FunctionComponent = () => {
  const { close } = useContext(NotificationContext)

  return (
    <div onClick={close}>
      <Box pl={96} relative className={s.item}>
        <div className={s.img} />
        <Box mb={4}>
          <Text size="14-24" uppercase semibold message={messages.title} html />
        </Box>
        <Box mb={4}>
          <Text message={messages.text} html size="12-16" />
        </Box>
      </Box>
    </div>
  )
}


export default OutOfStockSubscription
